import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import { split } from '../../util/strings';
import { AnyTag, PropsOf } from '../DraggableList/types';

const useStyles = makeStyles(theme => ({
    root: {
        textAlign: 'center',
        fontWeight: 300,
        display: 'block',
        padding: theme.spacing(1),
        borderRadius: theme.spacing(1),
    },
    mainTitle: {
        fontWeight: 700,
        display: 'block',
    },
    iconWrapper: {
        display: 'block',
        height: props => props.small ? theme.spacing(4) : theme.spacing(6),
        margin: 'auto',
        fill: 'transparent',
        fontSize: '2.2rem',
    },
    icon: {
        display: 'block',
        height: props => props.small ? theme.spacing(4) : theme.spacing(6),
        margin: 'auto',
        fill: 'transparent',
        fontSize: '2.2rem',
    },
}));

export interface ProductLabelProps<C extends AnyTag> {
    iconUrl: string;
    iconWrapper?: (content: React.ReactNode, props: {className: string}) => React.ReactNode;
    icon?: React.ReactNode;
    label: string;
    hideIcon?: boolean;
    className?: string;
    containerComponent?: C;
    containerProps?: PropsOf<C>;
    small?: boolean;
}

/**
 * @param {ProductLabelProps} props
 */
export const ProductLabel: React.FunctionComponent<ProductLabelProps<'div'>> = props => {
    const Container = props.containerComponent || 'div';

    const classes = useStyles(props);

    let icon = props.icon || <img src={props.iconUrl} alt="" className={classes.icon}/>;
    if (props.iconWrapper) {
        icon = props.iconWrapper(icon, { className: classes.icon });
    }

    return (
        <Container
            {...props.containerProps}
            className={clsx(classes.root, props.className)}
        >
            <div className={classes.iconWrapper}>
                {!props.hideIcon && icon}
            </div>
            <span>
                <span>{split(props.label, ' ', 1)[0]}</span>
                <span className={classes.mainTitle}>{split(props.label, ' ', 1)[1]}</span>
            </span>
        </Container>
    );
};
